<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>Project Details</li>
                <li></li>
            </ul>
            <h2 i18n>Project Details</h2>
        </div>
    </div>
</div>

<div class="blog-details-area ptb-100" [class.dark-blog-details-area]="themeService.isDark()">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-content">

                        <div class="entry-meta">
                            <ul>
                                <li>
                                    <i class='bx bx-folder-open'></i>
                                    <span i18n>Category</span>
                                    <a>{{project?.project_category.category_name}}</a>
                                </li>
                                <li>
                                    <i class='bx bx-current-location'></i>
                                    <span i18n>LOCATION</span>
                                    <a>{{project?.location}}</a>
                                </li>
                                <li>
                                    <i class='bx bx-group'></i>
                                    <span i18n>DONOR</span>
                                    <a>{{project?.donor}}</a>
                                </li>
                                <li>
                                    <i class='bx bx-calendar'></i>
                                    <span i18n>Project Date</span>
                                    <a>{{project?.start_date|date:'longDate'}} -
                                        {{project?.end_date|date:"longDate"}}</a>
                                </li>
                            </ul>
                        </div>
                        <h3>{{project?.name}}</h3>

                        <blockquote class="wp-block-quote" *ngIf="project?.achievements">
                            <h3 i18n>Achievements</h3>
                            <p>
                                {{project?.achievements}}
                            </p>
                        </blockquote>

                        <h3 i18n>Project Details</h3>
                        <p> {{project?.description}}</p>



                        <figure>
                            <img [src]="imageURL+project?.picture" style="max-height:25em" alt="image">
                        </figure>


                    </div>

                </div>

            </div>
        </div>
    </div>
</div>